import { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  messageTemplateSelectData,
  templateSelectData,
  listMessageTemplateData,
  setTitleData,
  setPhoneMessageData,
  setSMSMessageData,
  setEmailMessageData,
  setEnglishPositiveResponseData,
  setEnglishNegativeResponseData,
  setSpanishPositiveResponseData,
  setSpanishNegativeResponseData,
  setSelectionData,
} from '../../store/MessageTemplateSelect/actionCreator'
import { CircularProgress } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { formValidation } from '../MessageCreate/formValidation'
import MessageTemplateItems from '../MessageTemplateSelect/MessageTemplateSelectItems'
import { func, bool, string, arrayOf, shape, object } from 'prop-types'

const styles = (theme) => ({
  spinner: {
    color: theme.palette.primary.main,
  },
  homePage: {
    textAlign: 'center',
  },
  centerDiv: {
    margin: 'auto',
    padding: '0px',
    width: '20%',
    minWidth: 475,
  },
  leftDiv: {
    fontSize: 16,
    padding: '1px',
    margin: '1px',
    textAlign: 'left',
  },
  iconDelete: {
    fontSize: 24,
    padding: '1px',
    margin: '1px',
    textAlign: 'right',
    width: '100%',
  },
  iconStyle: {
    width: '36px',
    height: '36px',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  button: {
    margin: theme.spacing(1),
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
})

export class MessageTemplateSelectPage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      blossomID: this.props.fromParentblossomID,
    }
    this.setMessageTemplateData()
  }

  setMessageTemplateData() {
    this.props.listMessageTemplateData(this.state.blossomID)
  }

  selectionDataCallback = (selections) => {
    this.props.setSelectionData(selections)
  }

  populateTemplateData = (valueArr) => {
    const {
      setTitleData,
      callbackFromParentTitle,
      callbackFromParentTitleData,
      callbackFromParentPhoneMessage,
      callbackFromParentPhoneMessageData,
      callbackFromParentSMSMessage,
      callbackFromParentSMSMessageData,
      callbackFromParentEmailMessage,
      callbackFromParentEmailMessageData,
      callbackFromParentEnglishPositiveResponse,
      callbackFromParentEnglishPositiveResponseData,
      callbackFromParentEnglishNegativeResponse,
      callbackFromParentEnglishNegativeResponseData,
      callbackFromParentSpanishPositiveResponse,
      callbackFromParentSpanishPositiveResponseData,
      callbackFromParentSpanishNegativeResponse,
      callbackFromParentSpanishNegativeResponseData,
    } = this.props
    // do a quick type check
    if (!Array.isArray(valueArr)) {
      return
    } else {
      if (valueArr.length > 0) {
        if (typeof valueArr[0] !== 'object') {
          return
        }
      } else {
        return
      }
    }
    const value = valueArr[0]
    if ('original' in value) {
      setTitleData(value.original['message_title'])
      callbackFromParentTitle(
        formValidation(value.original['message_title'], 'text', 'boolean'),
      )
      callbackFromParentTitleData(value.original['message_title'])

      setPhoneMessageData(value.original['message_body_phone'])
      callbackFromParentPhoneMessage(
        formValidation(value.original['message_body_phone'], 'text', 'boolean'),
      )
      callbackFromParentPhoneMessageData(value.original['message_body_phone'])

      setSMSMessageData(value.original['message_body_sms'])
      callbackFromParentSMSMessage(
        formValidation(value.original['message_body_sms'], 'text', 'boolean'),
      )
      callbackFromParentSMSMessageData(value.original['message_body_sms'])

      setEmailMessageData(value.original['message_body_email'])
      callbackFromParentEmailMessage(
        formValidation(value.original['message_body_email'], 'text', 'boolean'),
      )
      callbackFromParentEmailMessageData(value.original['message_body_email'])

      setEnglishPositiveResponseData(
        value.original['message_response_positive'],
      )
      callbackFromParentEnglishPositiveResponse(
        formValidation(
          value.original['message_response_positive'],
          'text',
          'boolean',
        ),
      )
      callbackFromParentEnglishPositiveResponseData(
        value.original['message_response_positive'],
      )

      setEnglishNegativeResponseData(
        value.original['message_response_negative'],
      )
      callbackFromParentEnglishNegativeResponse(
        formValidation(
          value.original['message_response_negative'],
          'text',
          'boolean',
        ),
      )
      callbackFromParentEnglishNegativeResponseData(
        value.original['message_response_negative'],
      )

      setSpanishPositiveResponseData(
        value.original['message_response_positive_es'],
      )
      callbackFromParentSpanishPositiveResponse(
        formValidation(
          value.original['message_response_positive_es'],
          'text',
          'boolean',
        ),
      )
      callbackFromParentSpanishPositiveResponseData(
        value.original['message_response_positive_es'],
      )

      setSpanishNegativeResponseData(
        value.original['message_response_negative_es'],
      )
      callbackFromParentSpanishNegativeResponse(
        formValidation(
          value.original['message_response_negative_es'],
          'text',
          'boolean',
        ),
      )
      callbackFromParentSpanishNegativeResponseData(
        value.original['message_response_negative_es'],
      )
    }
  }

  static defaultProps = {}

  render() {
    const { classes, responseData, fetchingState, selectionData } = this.props
    const { blossomID } = this.state

    let tableData = ''
    if (responseData === '') {
      tableData = 'No data found in TOM Database'
    } else {
      tableData = (
        <MessageTemplateItems
          blossomIDFromParent={blossomID}
          dataFromParent={responseData}
          fetchingState={fetchingState}
          callbackFromParentSelectData={this.populateTemplateData}
          selectionsFromParent={selectionData}
          callbackFromParentSelections={this.selectionDataCallback}
        />
      )
    }

    // Create variables from values of matching keys
    let toRender = <br />

    if (fetchingState === false && responseData == null) {
      toRender = <br />
    } else if (fetchingState === true) {
      toRender = (
        <div>
          <CircularProgress className={classes.spinner} thickness={7} />
          <h3>loading...</h3>
        </div>
      )
    } else if (responseData != null) {
      toRender = <div className={classes.centerDiv}>{tableData}</div>
    }

    return (
      <div className={classes.homePage}>
        <br />
        {toRender}
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      messageTemplateSelectData,
      templateSelectData,
      listMessageTemplateData,
      setTitleData,
      setPhoneMessageData,
      setSMSMessageData,
      setEmailMessageData,
      setEnglishPositiveResponseData,
      setEnglishNegativeResponseData,
      setSpanishPositiveResponseData,
      setSpanishNegativeResponseData,
      setSelectionData,
    },
    dispatch,
  )

const mapStateToProps = (state) => ({
  messageTitle: state.templateSelectData.inputText,
  messagePhone: state.templateSelectData.inputPhoneMessage,
  messageSMS: state.templateSelectData.inputSMSMessage,
  messageEmail: state.templateSelectData.inputEmailMessage,
  responseData: state.templateSelectData.data,
  fetchingState: state.templateSelectData.fetching,
  englishPositiveResponse:
    state.templateSelectData.inputEnglishPositiveResponse,
  englishNegativeResponse:
    state.templateSelectData.inputEnglishNegativeResponse,
  spanishPositiveResponse:
    state.templateSelectData.inputSpanishPositiveResponse,
  spanishNegativeResponse:
    state.templateSelectData.inputSpanishNegativeResponse,
  selectionData: state.templateSelectData.selectionData,
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(MessageTemplateSelectPage))

MessageTemplateSelectPage.propTypes = {
  classes: object,
  responseData: arrayOf(
    shape({
      message_title: string,
    }),
  ),
  fetchingState: bool.isRequired,
  selectionData: object,
  fromParentblossomID: string.isRequired,
  setSelectionData: func.isRequired,
  setTitleData: func,
  listMessageTemplateData: func.isRequired,
  callbackFromParentTitle: func.isRequired,
  callbackFromParentTitleData: func.isRequired,
  callbackFromParentPhoneMessage: func.isRequired,
  callbackFromParentPhoneMessageData: func.isRequired,
  callbackFromParentSMSMessage: func.isRequired,
  callbackFromParentSMSMessageData: func.isRequired,
  callbackFromParentEmailMessage: func.isRequired,
  callbackFromParentEmailMessageData: func.isRequired,
  callbackFromParentEnglishPositiveResponse: func.isRequired,
  callbackFromParentEnglishPositiveResponseData: func.isRequired,
  callbackFromParentEnglishNegativeResponse: func.isRequired,
  callbackFromParentEnglishNegativeResponseData: func.isRequired,
  callbackFromParentSpanishPositiveResponse: func.isRequired,
  callbackFromParentSpanishPositiveResponseData: func.isRequired,
  callbackFromParentSpanishNegativeResponse: func.isRequired,
  callbackFromParentSpanishNegativeResponseData: func.isRequired,
}
